import styled from '@emotion/styled';
import Calendar from '@engineering/icons/calendar';
import { bodyBold } from '@silvertours/front-shared';
import type { StyledTextProps } from '@silvertours/front-shared';

const TopBarHeadline = styled.div<StyledTextProps>`
  ${bodyBold}
`;

const DatePickerButton = styled.button<{ isInvalid: boolean }>`
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0.625rem 1rem;
  border: 1px solid ${({ theme }) => theme.color.grey03};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  width: 100%;
  height: 3.5rem;
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  text-transform: capitalize;
  text-align: left;
  color: ${({ theme }) => theme.color.text};
  background-color: ${({ theme }) => theme.color.white};
  cursor: pointer;

  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.color.grey02};
  }

  &:focus-visible {
    outline: 0.125rem dashed ${({ theme }) => theme.color.secondary};
    outline-offset: 0.25rem;
  }
`;

const DatePickerValues = styled.span`
  display: inline-grid;
  grid-template-columns: 1fr min-content 1fr;
  gap: 0.5rem;
  align-items: center;

  ${({ theme }) => theme.mq('md')} {
    gap: 1rem;
  }
`;

const DatePickerValue = styled.time`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DateSeparator = styled.span`
  width: 1px;
  height: 1.5rem;
  background-color: ${({ theme }) => theme.color.grey01};
`;

const CalendarIcon = styled(Calendar)`
  display: none;
  width: 1.6rem;
  height: 1.6rem;
  fill: currentcolor;

  ${({ theme }) => theme.mq('md')} {
    display: block;
  }
`;

export {
  TopBarHeadline,
  DatePickerButton,
  DatePickerValues,
  DatePickerValue,
  DateSeparator,
  CalendarIcon,
};
